var map = {
	"./card15.png": 612,
	"./card41.png": 11,
	"./card42.png": 368,
	"./card52.png": 703,
	"./card64.png": 860,
	"./card66.png": 606,
	"./card69.png": 513,
	"./card72.png": 465,
	"./card76.png": 461,
	"./card87.png": 265,
	"./tools.png": 575,
	"./tools2.png": 445
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 417;